import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container mt-4">
      <h1 className="mb-4">Privacy Policy</h1>
      <p>
        We collect personal information like name and email when you use
        features such as Facebook or Google login.
      </p>
      <p>
        To personalize your experience: We may use the information to customize
        your experience within the app and provide content and features tailored
        to your interests.
      </p>
      <p>
        Third-party services like Facebook and Google may have their own privacy
        policies.
      </p>
      <p>We are committed to ensuring that your information is secure.</p>
      <p>
        For inquiries, contact us at{" "}
        <a href="mailto:kirtanpriya@gmail.com">kirtanpriya@gmail.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
